import React, { useContext } from "react";
import PropTypes from "prop-types";

import { ModalContext } from "../../../../components/ModalProvider";

import { ALL_NOTES_QUERY } from "../../../../graphql/Notes/Notes.graphql";
import { NOTE_COLUMNS } from "../columns";

import DataTable from "../../../../components/DataTable";

import EditCustomerNoteForm from "../../../../components/Customers/EditCustomerNoteForm";

const Notes = ({ id }) => {
  const { setModalOpen } = useContext(ModalContext);
  return (
    <DataTable
      columns={NOTE_COLUMNS}
      dataQuery={ALL_NOTES_QUERY}
      initialSortBy={[{ id: "CreatedDateTime", desc: true }]}
      name="Note"
      where={{ TableName: "Customers", RefRecId: parseInt(id) }}
      onRowClick={note =>
        setModalOpen(
          true,
          <EditCustomerNoteForm
            note={note}
            onComplete={() => setModalOpen(false, "")}
          />
        )
      }
    />
  );
};

Notes.propTypes = {
  id: PropTypes.number.isRequired
};
export default Notes;
